import { AVATAR_STATUSES_VARIANTS } from '../../constants'
import { ManagerAvatarVariantType, ManagerType, ManagerVacationStatusType } from '../../types'

const managerStatusToAvatarElementVariantMap: { [key in Exclude<ManagerVacationStatusType, 'none'>]: ManagerAvatarVariantType } = {
  holidays: AVATAR_STATUSES_VARIANTS.Vacation,
  sick: AVATAR_STATUSES_VARIANTS.SickLeave,
  trip: AVATAR_STATUSES_VARIANTS.BusinessTrip,
  vacation: AVATAR_STATUSES_VARIANTS.Vacation,
}

export const mapManagerStatusToAvatarElementVariant = (userManager?: ManagerType): ManagerAvatarVariantType | undefined => {
  if (!userManager) {
    return undefined
  }

  const managerLeave = userManager.leave

  if (managerLeave && managerLeave.leave_type !== 'none') {
    return managerStatusToAvatarElementVariantMap[managerLeave.leave_type]
  }

  return userManager.is_online ? AVATAR_STATUSES_VARIANTS.Online : AVATAR_STATUSES_VARIANTS.Offline
}
